<template>
  <div class="conversion-file-upload">
    <el-upload ref="upload" action="" :http-request="upload" :file-list="files" :limit="2" :disabled="disabled || uploading" :on-change="change" :on-remove="remove" :on-error="failed">
      <div v-if="!files.length" class="conversion-upload-box">
        <span v-if="!files.length" class="conversion-upload-tip"><b>点击上传{{ label }}</b></span>
        <span v-if="uploading" class="conversion-upload-progress">正在上传…</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
import Client from '@/utils/client';
import { fileUpload } from '@/views/components/ossUpload/index';

export default {
  name: 'DiscountConversionFileUpload',
  props: {
    label: { type: String, default: '文件' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { files: [], uploading: false, alive: true };
  },
  beforeDestroy() {
    this.alive = false;
  },
  methods: {
    change(file, files) {
      if (file.status === 'ready') {
        this.files = [file];
        this.$refs.upload.uploadFiles = [file];
        this.uploading = true;
        this.$emit('busy', true);
      } else {
        this.files = files.slice(-1);
      }
    },
    remove() {
      this.files = [];
      this.$emit('input', []);
    },
    failed(error) {
      if (!this.alive) return;
      this.$message.error((error && error.message) || '文件上传失败');
      this.$emit('input', []);
    },
    async upload(options) {
      try {
        const auth = await fileUpload();
        if (!auth || auth.success === false || !auth.data) {
          throw new Error((auth && auth.message) || '获取上传凭证失败');
        }
        const name = `tmp/${Date.now()}_${Math.random().toString(36).slice(2, 10)}_${options.file.name}`;
        const result = await Client(auth.data).put(name, options.file);
        if (!result.res || result.res.statusCode !== 200 || !result.url) {
          throw new Error('文件上传失败');
        }
        if (this.alive) {
          this.$emit('input', [result.url]);
        }
        return result;
      } catch (error) {
        throw error instanceof Error ? error : new Error('文件上传失败');
      } finally {
        if (this.alive) {
          this.uploading = false;
          this.$emit('busy', false);
        }
      }
    }
  }
};
</script>

<style>
.conversion-file-upload {
  .el-upload {
    display: block;
    width: 100%;
  }

  .el-upload-list {
    margin-top: 0;
  }

  .el-upload-list__item {
    height: auto;
    min-height: 40px;
    line-height: 20px;
    margin-top: 0;
    padding: 9px 32px 9px 12px;
    border: 1px solid #bfe6d1;
    border-radius: 8px;
    background: #f6fef9;
    box-sizing: border-box;
  }

  .el-upload-list__item:first-child {
    margin-top: 0;
  }

  .el-upload-list__item-name {
    display: block;
    margin: 0;
    color: #303133;
    overflow-wrap: anywhere;
  }

  .el-upload-list__item .el-icon-close {
    top: 12px;
    right: 10px;
  }

  .el-upload-list__item .el-icon-close-tip {
    display: none !important;
  }

  .el-upload-list__item.is-success .el-upload-list__item-status-label {
    display: none;
  }

  .conversion-upload-box {
    display: flex;
    min-height: 54px;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border: 1px dashed #d5d9e2;
    border-radius: 8px;
    background: #fbfcfe;
    box-sizing: border-box;
    cursor: pointer;
    transition: border-color .15s ease, background .15s ease;
  }

  .el-upload:hover .conversion-upload-box {
    border-color: #409eff;
    background: #f3f8ff;
  }

  .conversion-upload-tip {
    color: #909399;
    font-size: 13px;
  }

  .conversion-upload-tip b {
    margin-right: 4px;
    color: #409eff;
    font-weight: 500;
  }

  .conversion-upload-progress {
    color: #606266;
    font-size: 13px;
  }
}
</style>

